<template>
  <div v-if="hasErrors" class="alert-error sticky island" tabindex="-1" role="alert">
    <div class="icon">
      <div class="af-icons-md af-icons-md-alert-error"></div>
    </div>
    <div class="message">
      <ul class="validation-errors">
      <template v-for="(errors, key) in validationErrors">
        <li v-for="error in errors" :key="key">
          {{ error }}
        </li>
      </template>
      </ul>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  computed: {
    ...mapState('global', ['validationErrors']),
    hasErrors() {
      return Object.keys(this.validationErrors).length
    }
  }
}
</script>

<style scoped>

</style>
